<template lang="pug">
  .wrap
    page-title
      | Add a new alert
      span(slot='subtitle') Alerts are messages that can be sent to your team at any time. You can set a start and end time for your alerts so they can be seen at a specific time.

    alert-form(v-model='alert' @save='onSave' ref='form')
      template(slot='saveOptions')
        el-checkbox(v-model='createAnother') Save and create another

</template>

<script>
import { mapGetters, mapActions } from "vuex";
import CrudMixin from "@/shared/mixins/Crud";
import PageTitle from "@/shared/components/layout/PageTitle";
import AlertForm from "@/brapp/components/shared/alerts/AlertForm";

const getInitialAlertData = () => {
  return {
    subject: "",
    message: "",
    startDatetime: null,
    endDatetime: null,
    timezone: "",
    status: "draft",
    assignees: []
  };
};

export default {
  components: { PageTitle, AlertForm },
  mixins: [CrudMixin],
  inject: ["mainPane"],
  data() {
    return {
      alert: getInitialAlertData(),
      createAnother: false
    };
  },
  computed: {
    ...mapGetters({
      activeCompany: "auth/activeCompany"
    })
  },
  methods: {
    ...mapActions({
      createAlert: "alerts/createAlert"
    }),
    onSave({ valid }) {
      if (!valid) {
        this.$notify({
          title: "Error",
          message: "Please fix the validation errors",
          type: "error"
        });
        return;
      }

      const newAlertData = {
        ...this.alert,
        company: this.activeCompany.id,
        assigneeUserIds: this.alert.assignees
          .filter(a => a.user)
          .map(u => u.user.id),
        assigneeAppLicenseGroupIds: this.alert.assignees
          .filter(a => a.appLicenseGroup)
          .map(g => g.appLicenseGroup)
      };

      this.createAlert({ data: newAlertData })
        .then(data => {
          this.$notify({
            title: "Success",
            message: "Alert successfully created",
            type: "success"
          });

          if (this.createAnother) {
            this.alert = getInitialAlertData();
            this.$refs.form.$refs.scheduler.resetPickerValue();
            this.mainPane.scroll({ to: "top" });
          } else {
            this.$router.push({
              name: "alertEdit",
              params: { alertId: data.id }
            });
          }
        })
        .catch(() => {
          this.loading = false;
          this.$notify({
            title: "Error",
            message: "Oops, something went wrong",
            type: "error"
          });
        });
    }
  }
};
</script>

<style scoped lang="scss"></style>
